<template>
    <tr :class="{'locked-row': todo.isLocked}">
        <td>
            <div :class="{'locked-block': todo.isLocked}">
                <img
                    src="/img/svg/icons-lock.svg"
                    alt="" class="lock"
                    v-if="todo.isLocked"
                >
                <div>
                    <div class="color--dark-text d-flex">
                        <a :href="`/master-admin/to-do/${todo.id}/edit`">
                            <b>{{ todo.title }}</b>
                        </a>
                        <a
                            href="javascript:void(0)"
                            class="color--secondary ml-2"
                            @click="showModal(todo.id)"><i class="fas fa-eye"></i></a>
                        <EyesShowModal
                            :title="`To Do`"
                            :modal-text="todo.description"
                            :modalId="getModalId(todo.id)"
                        ></EyesShowModal>
                    </div>
                    <div class="small-text">
                        <span>Created</span>
                        <em>{{ todo.creator.name }} {{ todo.creator.last_name }}</em> |
                        <span>{{ calculateDate(todo.created_at) }}</span> |
                        <span>Assigned: {{ todo.assigned_person.name }} {{ todo.assigned_person.last_name }}</span>
                        <em> {{ todo.forward_from?.name ?? '' }}
                            {{ todo.forward_from?.last_name ?? '' }}</em>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <span :class="showColorPriority(todo.priority)">{{ todo.priority | capitalizeFirst }}</span>
        </td>
        <td>
            {{ todo.dead_line ? calculateDate(todo.dead_line) : ''}}
        </td>
        <td>
            <span
                :class="{
                   'color--orange': todo.status === 'pending',
                   'color--green': todo.status === 'complete'
                }">{{ todo.status | capitalizeFirst }}</span>
        </td>
        <td class="text-right">
            <div class="action-block">
                <a href="javascript:void(0)"
                   class="edit-link"
                   @click="showForwardModal(todo.id)"
                ><img src="/img/svg/icons-arrpow.svg" alt="">
                </a>

                <AddNewItemModal
                    title="Select Employee"
                    confirm-text="Send"
                    :id="getForwardModalId(todo.id)"
                    reject-text="Cancel"
                    type="select"
                    :positions="users"
                    @confirm="forwardTodo"
                ></AddNewItemModal>

                <button
                    v-if="deletingTodo"
                    class="delete-link"
                    @click="showDeleteModal(todo.id)"
                ><img src="/img/svg/on.svg" alt="delete"></button>

                <ActionModal
                    confirm-text="Yes"
                    reject-text="No"
                    :modalId="getDeleteModalId(todo.id)"
                    @confirm="deleteItem(todo.id)">
                    <template #body>
                        <div class="text-center mb-4">
                            <h4>
                                Are you sure you want <br> to delete this item?
                            </h4>
                        </div>
                    </template>
                </ActionModal>
            </div>
        </td>
    </tr>
</template>

<script>
import ToDoService from "./services/ToDoService";
import EyesShowModal from "../../../../../resources/js/components/EyesShowModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import AddNewItemModal from "../../../../../resources/js/components/AddNewItemModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";

export default {
    name: 'ToDoListItem',
    components: {
        AddNewItemModal,
        ActionModal,
        EyesShowModal
    },
    mixins: [DateConverter, StyleHandler, ModalHandler,],
    emits: ['delete', 'update-list'],
    props: {
        todo: Object,
        deletingTodo: Boolean,
        listOfTodo: Array,
        users: Array
    },
    data() {
        return {
            loading: true,
            todoList: this.listOfTodo ?? [],
            currentTodoId: null,
        }
    },
    methods: {
       deleteItem(id) {
           this.$emit('delete', id);
       },
        async forwardTodo(id) {
           this.$showLoadingMessage()
           if (id) {
               try {
                   await ToDoService.forwardTodoTo(this.currentTodoId, id);
                   $(`#forwardModalId-${this.currentTodoId}`).modal('hide');
                   this.$showSuccessMessage('ToDo has been forwarded!');
                   this.$emit('update-list')
               } catch (error) {
                   this.$showErrorMessage('The to-do was not forwarded. Please try again');
                   console.error(error);
               }
           } else {
               this.$showErrorMessage('The to-do was not forwarded. Please select assigned person');
           }
        },
        getForwardModalId(todoId) {
            this.currentTodoId = todoId
            return `forwardModalId-${todoId}`
        },

        showForwardModal(id) {
            $(`#forwardModalId-${id}`).modal()
        },
    },


}

</script>


<style scoped>

</style>
